import { createReducer } from '@reduxjs/toolkit';
import { emailVerificationActions } from 'features/admin-email-verification/redux/email-verification.actions';

export const initialState = {
  loadingStatus: false as boolean,
  error: null as string | null,
  isVerificationSuccessfullySent: null as boolean | null,
  isEmailVerifiedSuccessfully: null as boolean | null,
} as const;

const emailVerificationReducer = createReducer(initialState, (builder) => {
  builder.addCase(emailVerificationActions.resetState, () => {
    return {
      ...initialState,
    };
  });
  builder.addCase(emailVerificationActions.verifyEmailRequest, (state) => {
    return {
      ...state,
      loadingStatus: true,
      isEmailVerifiedSuccessfully: null,
      error: null,
    };
  });
  builder.addCase(emailVerificationActions.verifyEmailSuccess, (state) => {
    return {
      ...state,
      loadingStatus: false,
      isEmailVerifiedSuccessfully: true,
    };
  });
  builder.addCase(
    emailVerificationActions.verifyEmailFailure,
    (state, { payload }) => {
      return {
        ...state,
        loadingStatus: false,
        isEmailVerifiedSuccessfully: false,
        error: payload,
      };
    }
  );

  builder.addCase(
    emailVerificationActions.sendEmailVerificationTokenRequest,
    (state) => {
      return {
        ...state,
        loadingStatus: true,
        error: null,
        isVerificationSuccessfullySent: null,
      };
    }
  );
  builder.addCase(
    emailVerificationActions.sendEmailVerificationTokenSuccess,
    (state) => {
      return {
        ...state,
        loadingStatus: false,
        isVerificationSuccessfullySent: true,
      };
    }
  );
  builder.addCase(
    emailVerificationActions.sendEmailVerificationTokenFailure,
    (state) => {
      return {
        ...state,
        loadingStatus: false,
        isVerificationSuccessfullySent: false,
      };
    }
  );
});

export default emailVerificationReducer;
